import { getFirebase } from 'firestorter';

import { LeadHistoryType, LeadState, SalesStage } from '../Model/Lead';
import CollectionName from '../../utils/collections';
import { addLeadComment } from './message';

const SalesStageWorkFlow = [
  SalesStage.NEW_LEAD,
  SalesStage.FIRST_MESSAGE,
  SalesStage.SECOND_MESSAGE,
  SalesStage.CALENDLY_SCHEDULED,
];

const getNextSalesStage = (currentSalesStage) => {
  const currentIndex = SalesStageWorkFlow.indexOf(currentSalesStage);
  if (currentIndex >= 0 && currentIndex < SalesStageWorkFlow.length - 1) {
    return SalesStageWorkFlow[currentIndex + 1];
  }
  return null;
};

const rescheduleViaSDR = async (leadDoc, reason, userId, userName) => {
  const db = getFirebase().default.firestore();
  const leadRef = db.collection(CollectionName.LEADS).doc(leadDoc.id);

  await db.runTransaction(async (transaction) => {
    // Add a comment to the lead conversation, so that we can track who sent the lead back to SDR.
    await addLeadComment({
      leadId: leadDoc.id,
      coachId: leadDoc.coach,
      message: reason,
      createdBy: userId,
      createdByUserName: userName,
    }, transaction);

    // Add a new entry to the lead history, so that we can track who sent the lead back to SDR
    const sentToRescheduleHistoryDocRef = db.collection(CollectionName.LEAD_HISTORY).doc();
    transaction.set(sentToRescheduleHistoryDocRef, {
      leadId: leadDoc.id,
      coachId: leadDoc.coach,
      value: { reason },
      reason,
      createdAt: new Date(),
      activityType: LeadHistoryType.SENT_TO_RESCHEDULE,
      createdBy: userId,
      createdByUserName: userName,
    });

    // Send lead back to IN_DIALOGUE.
    transaction.update(leadRef, {
      salesStage: SalesStage.IN_DIALOGUE,
      state: LeadState.IS_CONTACTED,
    });

    // Add a new entry to the lead history, so that we can track who sent the lead back to SDR
    const salesStageHistoryDocRef = db.collection(CollectionName.LEAD_HISTORY).doc();
    transaction.set(salesStageHistoryDocRef, {
      leadId: leadDoc.id,
      coachId: leadDoc.coach,
      value: SalesStage.IN_DIALOGUE,
      createdAt: new Date(),
      activityType: LeadHistoryType.SALES_STAGE_CHANGE,
      createdBy: userId,
      createdByUserName: userName,
    });
  });
};

// Group rows by filter, so it's easier to switch between button filters
const groupLeadsBySalesStage = (leads, salesStagesOptions, salesStagesFilterChecks) => {
  const groupedRows = {};
  const counters = {};
  leads.forEach((lead) => {
    Object.values(salesStagesOptions).forEach((filter) => {
      if (!groupedRows[filter]) {
        groupedRows[filter] = [];
        counters[filter] = 0;
      }
      const filterCheck = salesStagesFilterChecks[filter];
      if (filterCheck && filterCheck(lead)) {
        groupedRows[filter].push(lead);
        counters[filter] += 1;
      }
    });
  });
  return [groupedRows, counters];
};

export {
  SalesStageWorkFlow,
  getNextSalesStage,
  rescheduleViaSDR,
  groupLeadsBySalesStage,
};
